import triggerTracking from '@blueprint/tracking';

export const TRACKING_EVENT = 'GAEvent';
export const TRACKING_CATEGORY = 'user_prompt';
export const MODAL_CLOSED_TRACKING_EVENT = 'modal_closed';
export const MODAL_SHOWN_TRACKING_EVENT = 'modal_shown';
export const MODAL_SIGNIN_TRACKING_EVENT = 'click_to_signin';
export const MODAL_REGISTER_TRACKING_EVENT = 'click_to_register';

const getCloseModaltracking = (label: string) => {
    return triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: MODAL_CLOSED_TRACKING_EVENT,
        eventLabel: label
    });
};

const getOpenModaltracking = (label: string) => {
    return triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: MODAL_SHOWN_TRACKING_EVENT,
        eventLabel: label
    });
};

const getRegisterModaltracking = (label: string) => {
    return triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: MODAL_REGISTER_TRACKING_EVENT,
        eventLabel: label
    });
};

const getSignInModaltracking = (label: string) => {
    return triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: MODAL_SIGNIN_TRACKING_EVENT,
        eventLabel: label
    });
};

export const trackPromptClose = (journey: string) => {
    getCloseModaltracking(journey);
};

export const trackPromptOpen = (journey: string) => {
    getOpenModaltracking(journey);
};

export const trackPromptRegister = (journey: string) => {
    getRegisterModaltracking(journey);
};

export const trackPromptSignIn = (journey: string) => {
    getSignInModaltracking(journey);
};

export const trackPromptExperiment = (
    experiment: string,
    variation: string | null | undefined
) => {
    if (variation) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'optimizely',
            eventAction: experiment,
            eventLabel: variation
        });
    }
};
